// src/loaders/autoLoginLoader.js

import authConfig from 'config/auth';
const PUBLIC_URL = process.env.PUBLIC_URL;

export async function autoLogoutLoader() {
  window.localStorage.setItem('kerpUserData2.1', '');
  window.localStorage.setItem(authConfig.storageTokenKeyName, null);
  window.localStorage.setItem('krpLogin', false);
  window.localStorage.setItem('loginInMobileApp', false);
  window.location.assign(`${PUBLIC_URL}/`);
}
